export class DirectorySearchFilter {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "users",
            "baseName": "users",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "sharedDrives",
            "baseName": "sharedDrives",
            "type": "boolean",
            "format": ""
        },
        {
            "name": "groups",
            "baseName": "groups",
            "type": "boolean",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DirectorySearchFilter.attributeTypeMap;
    }
    constructor() {
    }
}
